const html = require("./html/asnDetailRowsView.html");
import {setElementsFromScope, swapClasses, insertValAndManageFocus, show, hide, handleDisplayFor} from "../../../utilities/selectorHelpers";
import {unbindAll, extractElements} from "../../../utilities/viewHelpers";
import _ from "underscore";
import $ from "jquery";
import AsnShippingPalletStore from "../../../stores/AsnShippingPalletStore";
import AsnStore from "../../../stores/AsnStore";
import AsnShippingPalletRowView from "./AsnShippingPalletRowView";

const elementsMap = {
  asnDetailRowsOuter: ".shipping-asn-details-rows-outer",
  casePalletTitle: ".case-pallet-title",
  asnDetailLength: ".asn-detail-length",
  asnDetailWidth: ".asn-detail-width",
  asnDetailHeight: ".asn-detail-height",
  asnDetailWeight: ".asn-detail-weight",
  applyDimensionToAllBtn : ".apply-to-all-btn",
  stackablePalletCheckbox: ".stackable-pallet-checkbox"
}
 
export default function AsnShippingPalletRowsView(_unused, {
  getAsn,
  getAsnShipppingPallets,
  onAsnShippingPalletFieldsChange, 
  onAsnShippingPalletFieldChange,
  onAsnShippingPalletsGroupFieldChange,
  totalNewPallets
}){
  const self = this;
  self._element = $();
  const els = {};
  let asnShippingPallets = [];

  self.init = function(){
    render();
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
  }


  function bindElements(){
    bindApplyDimensionAndWeight();
    $(document).on("input", elementsMap.asnDetailLength,  handleAsnDetailGroupFieldChange("asp_pallet_length"));
    $(document).on("input", elementsMap.asnDetailWidth, handleAsnDetailGroupFieldChange("asp_pallet_width"));
    $(document).on("input", elementsMap.asnDetailHeight, handleAsnDetailGroupFieldChange("asp_pallet_height"));
    $(document).on("input", elementsMap.asnDetailWeight, handleAsnDetailGroupFieldChange("asp_pallet_weight"));
    $(document).on("click", elementsMap.stackablePalletCheckbox, handleAsnFieldCheckboxChange("asp_pallet_stackable"));
  }

  function bindApplyDimensionAndWeight(){
    $(document).on("click",  elementsMap.applyDimensionToAllBtn, function(e){
      let asnShippingPalletId = $(this).closest('.shipping-asn-detail-row').data('current-pallet-id');
      AsnShippingPalletStore.copyDimensionsToAllCasesForSameAsn(asnShippingPalletId);
     });
  }
  function handleAsnFieldCheckboxChange(key){
    return function(e){
      //onAsnShippingPalletFieldChange(rowIdx, key, !!$(this).is(":checked"));
      let rowIdx = $(this).closest('.shipping-asn-detail-row').data('current-row-idx');
      onAsnShippingPalletsGroupFieldChange(rowIdx, key, !!$(this).is(":checked"));
    }
  }
  function setWidgets(){

  }

  self.getElement = function(){
    return self._element;
  }

  function update(){
    updateSelf();
    updateChildren();
  }

  function updateSelf(){
    updateCasePalletLabel();
  }

  function updateCasePalletLabel(){
    els.casePalletTitle.text('Pallet');
  }


  function updateChildren(){
    unbindAll(asnShippingPallets);
      asnShippingPallets = renderAsnShippingPallets();
     els.asnDetailRowsOuter.html(extractElements(asnShippingPallets));
  }


  function bindStores(){
    AsnStore.bindListener("asns:shipping_method_changed", update);
  }

  self.unbindListeners = function(){

  }


  function render(){
    self._element = $(html);
    setElements();
    setWidgets();
    update();
    bindStores();
    bindElements();
  }

  
    function handleAsnDetailGroupFieldChange(key){
    return function(e){

      let val = $(this).val();
      // only parseInt if it's a number,
      // otherwise this field will end up
      // as a NaN
      if(_.isNumber(val)){
        val = parseInt(val, 10);
      }
      let rowIdx = $(this).closest('.shipping-asn-detail-row').data('current-row-idx');
      onAsnShippingPalletsGroupFieldChange(rowIdx, key, val);
      // options[funcName](rowIdx, val);
    };
  }

  function renderAsnShippingPallets(){
    
    return  _(getAsnShipppingPallets()).map((asnShippingPalletGroup, rowIdx)=>{
      // get the first asnDetail in the Pallet/case,
      // as all these values should be the same for the given
      // AsnDetailRowView
      // rowIdx = rowIdx + 1;
      // const asnShippingPallet = asnShippingPalletGroup[0];
      const asnShippingPalletRowView = new AsnShippingPalletRowView(asnShippingPalletGroup, {
        onAsnShippingPalletFieldChange,
        rowIdx,
      getAsnShipppingPallets,
      onAsnShippingPalletsGroupFieldChange
      });
      asnShippingPalletRowView.init();
      return asnShippingPalletRowView;
    });
  }

}


// WEBPACK FOOTER //
// ./src/pages/asns/ShippingTab/AsnShippingPalletRowsView.js